.fineprintTextLight {
    --text-color: var(--color-white);
    --shadow-color: var(--color-black);
}

.fineprintContainer {
    bottom: 2px;
    position: absolute;
}

.fineprint {
    color: var(--text-color, var(--color-black));
    padding: 0 2vw;

    // Overriding the default Rich Text styles
    // ...in a very regrettable way.
    & * {
        font-size: 12px !important;
        line-height: 1 !important;
    }

    & a {
        color: var(--text-color) !important;
        text-transform: none !important;
    }

    & p {
        margin-bottom: 0;
    }
}

.fineprintDropshadow {
    // Overriding the default Rich Text styles
    // ...in a very regrettable way.
    & * {
        text-shadow: -1px 1px 3px var(--shadow-color, var(--color-white));
    }
}
